<template>
  <div>
    <b-overlay
      :show="showPayment"
      rounded="sm"
    >
      <template #overlay>
        <div class="text-center">
          <div class="h2 mb-0">
            <b-icon-watch
              font-scale="3"
              animation="cylon"
            />
          </div>
          <h2 class="text-dark">
            Procesando ....
          </h2>
        </div>
      </template>
      <div v-if="show">
        <b-col md="12">
          <b-spinner
            variant="secondary"
            class="mr-1"
          />
          <span class="text-secondary">Consultando Balance...</span>
        </b-col>
      </div>
      <div v-else>
        <div v-if="balance_pesos <= 0">
          <b-alert
            variant="warning"
            show
            class="mb-0"
          >
            <div class="alert-body">
              <feather-icon
                icon="InfoIcon"
                class="mr-50"
              />
              No tiene un balance pendiente de pago. Gracias por
              mantener su cuenta al día. 👋
            </div>
          </b-alert>
        </div>
        <div v-else>
          <b-col md="12">
            <statistic-card-horizontal
              icon="CheckIcon"
              color="danger"
              :statistic="balance_pesos"
              statistic-title="Balance Pesos"
            />
          </b-col>
          <b-col md="12">
            <statistic-card-horizontal
              icon="CheckIcon"
              color="success"
              :statistic="balance_dolar"
              statistic-title="Pago en Dolares"
            />
          </b-col>
          <b-col
            md="12"
            class="mt-2"
          >
            <b-card>
              <h4 class="mb-2">
                Seleccione su método de pago preferido:
              </h4>

              <b-form-group>
                <b-form-radio-group
                  v-model="selectedPaymentMethod"
                  :options="paymentOptions"
                  name="payment-method"
                  stacked
                  class="custom-radio-lg"
                />
              </b-form-group>
            </b-card>
          </b-col>
          <template v-if="selectedPaymentMethod === 'azul'">
            <b-col
              md="12"
              class="mt-1"
            >
              <azul :contract="contract" />
            </b-col>
          </template>
          <template v-if="selectedPaymentMethod === 'paypal'">
            <b-col
              md="12"
              class="mt-2"
            >
              <b-button
                variant="info"
                block
                size="lg"
                :disabled="disabled"
                @click="savePayPal()"
              >
                Continuar el pago
              </b-button>
            </b-col>
            <b-col md="12">
              <b-form
                align="center"
                class="mt-5"
              >
                <div id="paypal-button-container" />
              </b-form>
            </b-col>
          </template>
        </div>
      </div>
      <b-col
        md="12"
        class="mt-1"
      >
        <hr>
      </b-col>
      <div
        align="center"
        class="mt-5"
      >
        <b-card-text class="text-muted">
          Aceptamos
        </b-card-text>
      </div>
      <div align="center">
        <b-img
          :src="imgFooter"
          alt="Logo"
          style="width: 300px; height: 60px"
        />
      </div>
      <div
        align="center"
        class="mt-2"
      >
        <b-img
          :src="imgPayPal"
          alt="Logo"
        />
      </div>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { fetchValidateToken } from "@/auth/EnsureTokenIsValid"
import router from "@/router"
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue"
import axios from 'axios'
import {
  BAlert,
  BButton,
  BCard,
  BCardText,
  BCol,
  BForm,
  BFormGroup,
  BFormRadioGroup,
  BIconWatch,
  BImg,
  BOverlay,
  BSpinner,
} from "bootstrap-vue"
import Azul from "./Azul.vue"

export default {
  components: {
    BOverlay,
    BIconWatch,
    BCardText,
    BImg,
    BCol,
    BAlert,
    BSpinner,
    BForm,
    BButton,
    StatisticCardHorizontal,
    Azul,
    BCard,
    BFormGroup,
    BFormRadioGroup,
  },
  props: {
    contract: {
      type: Object,
      required: true,
    },
    idcontrato: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      payee: "",
      userData: JSON.parse(localStorage.getItem("userData")),
      balance_pesos: 0,
      balance_dolar: 0,
      idpayment: null,
      disabled: false,
      showPayment: false,
      imgFooter: require("@/assets/images/logo/footer-card.png"),
      imgPayPal: require("@/assets/images/logo/paypal.png"),
      selectedPaymentMethod: null,
      paymentOptions: [
        { text: 'Pagar con Tarjeta de Crédito/Débito (Azul)', value: 'azul' },
        { text: 'Pagar con PayPal', value: 'paypal' },
      ],
    }
  },
  created() {
    this.searchBalance()
    this.loadPayPal()
  },
  mounted() {
    fetchValidateToken()
  },
  methods: {
    searchBalance() {
      this.show = true
      this.$http
        .get("/contrato-balance", {
          params: {
            idcontrato: this.idcontrato,
            idusuario: this.userData.id,
            opresumen: 1,
          },
        })
        .then((response) => {
          this.show = false
          if (response.data) {
            this.balance_pesos = response.data.balance_pesos
            this.balance_dolar = response.data.balance_dolar
          }
        })
        .catch((error) => {
          this.show = false
          console.log(error)
        })
    },
    loadPayPal() {
      this.$http
        .get("/paypal", {
          params: {
            estado: "A",
          },
        })
        .then((response) => {
          const key = response.data.id
          this.payee = response.data.mail
          this.loadJsPayPal(key)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    loadJsPayPal(key) {
      if (!key) {
        this.$swal({
          title: "Error",
          text: "Intente mas tarde, no se pudo cargar el formulario de pago.",
          icon: "error",
        })

        return
      }

      const paypal = document.createElement("script")
      paypal.setAttribute(
        "src",
        `https://www.paypal.com/sdk/js?client-id=${key}`,
      )
      document.head.appendChild(paypal)
    },
    savePayPal() {
      if (this.payee === "") {
        this.$swal({
          title: "Error",
          text: "Intente mas tarde, no se pudo cargar el formulario de pago.",
          icon: "error",
        })

        return
      }

      this.disabled = true
      this.$http
        .post(`${process.env.VUE_APP_API_URL}/payment`, {
          idcontrato: this.idcontrato,
          balance_dolar: this.balance_dolar,
          balance_pesos: this.balance_pesos,
          idusuario: this.userData.id,
        })
        .then((response) => {
          this.idpayment = response.data.idpayment
          this.loadFormPayPal(this.idpayment)
        })
        .catch((error) => {
          this.disabled = false
          this.$swal({
            title: "Error",
            text: error.response
              ? error.response.data.error
              : error.message,
            icon: "error",
          })
        })
    },
    loadFormPayPal(idpayment) {
      const amount = String(this.balance_dolar)
      const {contract} = this

      // eslint-disable-next-line no-undef
      paypal
        .Buttons({
          createOrder (data, actions) {
            return actions.order.create({
              purchase_units: [
                {
                  description:
                                        `NIC: ${
                                          contract.codigo
                                        } Balance: DOP ${
                                          contract.balance_pesos}`,
                  amount: {
                    value: amount,
                  },
                  payee: {
                    email_address: this.payee,
                  },
                },
              ],
              payer: {
                email_address: contract.email,
                name: {
                  given_name: contract.nombres,
                  surname: contract.apellidos,
                },
                address: {
                  address_line_1: contract.direccion,
                  address_line_2: "",
                  admin_area_2: "",
                  admin_area_1: "",
                  postal_code: "",
                  country_code: "DO",
                },
              },
            })
          },
          onApprove (data, actions) {
            return actions.order.capture().then(function (details) {
              axios
                .put(`${process.env.VUE_APP_API_URL}/payment/${idpayment}`, {
                  id: details.id,
                  status: details.status,
                  res: details,
                })
                .then(() => {
                  router.push({ name: "perfil" })
                })
                .catch((error) => {
                  console.log(error)
                })
            })
          },
          onError (err) {
            console.log(err)
            router.push({ name: "perfil" })
          },
        })
        .render("#paypal-button-container")
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-radio-lg {
    margin-left: 4rem;

  ::v-deep .custom-control {
    padding-left: 1rem;
    margin-bottom: 2rem;
    min-height: 2rem;
    display: flex;
    align-items: center;

    .custom-control-label {
      font-size: 1.2rem;
      line-height: 2rem;
      cursor: pointer;

      &::before,
      &::after {
        width: 2rem;
        height: 2rem;
        left: -3rem;
        top: 0;
        border-width: 2px;
      }

      &::after {
        background-size: 60%;
      }
    }

    &:hover .custom-control-label::before {
      box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
    }
  }
}
</style>
